import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import StandardLayout from '../../layouts/StandardLayout';
import { Switch } from 'react-router';
import AccountSubPage from './AccountSubPage';
import ProspectsSubPage from './ProspectsSubPage';
import ManageSubPage from './ManageSubPage';
import AuthorizedRoute from '../../common/AuthorizedRoute';
import { DashboardPage } from './DashboardPage';
import { Roles } from '../../../utilities/Enums';
import AuditLogPage from './AuditLogPage';
import ProspectSignupReportPage from './ProspectSignupReportPage';
import { AnalyticsDashboard } from './AnalyticsDashboard';

interface State { }

interface Props extends RouteComponentProps<{}> { }

class AdminPage extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {};
    }
    render() {
        return (
            <StandardLayout>
                <div className="content container-fluid admin-page">
                    <Switch>
                        <AuthorizedRoute path="/admin" exact={true} component={AccountSubPage} />
                        <AuthorizedRoute path="/admin/dashboard" component={DashboardPage} />
                        <AuthorizedRoute path="/admin/analytics" component={AnalyticsDashboard}/>
                        <AuthorizedRoute path="/admin/account" component={AccountSubPage} />
                        <AuthorizedRoute path="/admin/prospects" component={ProspectsSubPage} />
                        <AuthorizedRoute path="/admin/manage" component={ManageSubPage} />
                        <AuthorizedRoute
                            path="/admin/audit_log"
                            roles={[Roles.SystemAdmin]}
                            component={AuditLogPage}
                        />
                        <AuthorizedRoute
                            path="/admin/prospect_signup_report"
                            roles={[Roles.SystemAdmin]}
                            component={ProspectSignupReportPage}
                        />
                    </Switch>
                </div>
            </StandardLayout>
        );
    }
}

export default withRouter<Props>(AdminPage);



// WEBPACK FOOTER //
// ./src/components/pages/admin/AdminPage.tsx